export default [
  {
    title: 'Dashboard',
    icon: 'mdi-monitor-dashboard',
    route: '/home',
    // action: 'read',
    // resource: 'Home',
    // tag: '2',
    // tagVariant: 'light-warning',
    // children: [
    //   {
    //     title: 'eCommerce',
    //     route: 'dashboard-ecommerce',
    //   },
    //   {
    //     title: 'Analytics',
    //     route: 'dashboard-analytics',
    //   },
    // ],
  },
];
